import { render, staticRenderFns } from "./loanPerk.vue?vue&type=template&id=4fc2e69b&scoped=true&lang=html"
import script from "./loanPerk.vue?vue&type=script&lang=js"
export * from "./loanPerk.vue?vue&type=script&lang=js"
import style0 from "./loanPerk.vue?vue&type=style&index=0&id=4fc2e69b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc2e69b",
  null
  
)

export default component.exports